import React, { useState, useRef, useEffect } from "react";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";

import DatabaseService from "../services/database.service.js";
import AuthService from "../services/auth.service";

import EventBus from "../common/EventBus";

import "bootstrap/dist/css/bootstrap.min.css";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// Remove MenuItem import
// import { MenuItem } from "@mui/material";
import Select from 'react-select';
import { customSelectTheme } from '../common/CustomSelectTheme.js'

const Profile = () => {

  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [messagePassword, setMessagePassword] = useState("");
  const [successful, setSuccessful] = useState(false);

  const [devices, setDevices] = useState([]);
  const [selectedDevice, setSelectedDevice] = useState(null);

  const checkBtn = useRef();
  const form = useRef();

  const currentUser = AuthService.getCurrentUser();
  const isAdmin = currentUser.roles.includes("admin_smart")
  const isPartner = currentUser.roles.includes("partner")

  const [raceUserName, setRaceUserName] = useState(currentUser.race_username !== 'null' ? currentUser.race_username : "");

  const raceDisabled = (currentUser.race_team == 0)
  const contactRage = "Contact Rage Mechanics to join a race team"

  const deviceOptions = devices.map(device => ({
    value: device,
    label: `${device.ble_name} (${device.mac_custom})${(isAdmin || isPartner) && device.user_id ? " - " + device.user_id : ""
      }`,
  }));

  const handleDeviceChange = (selectedOption) => {
    setSelectedDevice(selectedOption);
  };

  const loadDevices = () => {
    DatabaseService.getDevices().then((response) => {
      setDevices(response.data);
    });
  };

  useEffect(() => {
    loadDevices();
  }, []);

  const required = (value) => {
    if (!value) {
      return (
        <div className="invalid-feedback d-block">
          This field is required!
        </div>
      );
    }
  };

  const onChangeRaceUsername = (e) => {
    const raceUserName = e.target.value;
    setRaceUserName(raceUserName);
  };

  const onChangePassword = (e) => {
    const password = e.target.value;
    setPassword(password);
  };

  const onChangePassword2 = (e) => {
    const password = e.target.value;
    setPassword2(password);
  };

  const handleRaceUsername = (e) => {
    e.preventDefault();
    DatabaseService.changeRaceUsername(raceUserName).then((response) => {
      if (response.status === 204) {
        AuthService.changeRaceUsername(raceUserName);

        toast.success("Name changed", {
          position: "bottom-right",
          autoClose: 2000
        });
      } else {
        toast.error("Error while changing the name", {
          position: "bottom-right",
          autoClose: 2000
        });
      }
    });
  };

  const handleRegister = (e) => {
    e.preventDefault();

    if (password !== password2) {
      setMessagePassword("password must match");
      setSuccessful(false);
      return;
    }

    setMessagePassword("");
    setSuccessful(false);

    form.current.validateAll();

    if (checkBtn.current.context._errors.length === 0) {

      DatabaseService.changePassword(password).then(
        (response) => {
          setMessagePassword("Password changed!");
          setSuccessful(true);
        },
        (error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();

          setMessagePassword(resMessage);
          setSuccessful(false);
        }
      );
    }
  };


  const handleUnregisterDevice = (e) => {
    e.preventDefault();
    if (selectedDevice && selectedDevice.value) {
      DatabaseService.removeUserDevice(selectedDevice.value.mac_custom, currentUser.email).then((response) => {
        if (response.status === 200 && response.data >= 0) {
          toast.success("Device unregistered successfully", {
            position: "bottom-right",
            autoClose: 2000
          });
          loadDevices();  // Reload devices after unregistering one
          setSelectedDevice(null); // Reset the selected device
        } else {
          toast.error("Error while unregistering the device", {
            position: "bottom-right",
            autoClose: 2000
          });
        }
      });
    }
  };

  const handleDelete = () => {
    const confirmed = window.confirm('Are you sure you want to delete this data?');
    if (confirmed) {
      DatabaseService.deleteAccount();
      EventBus.dispatch("logout");
    }
  };

  return (
    <div className="container">
      <ToastContainer />

      <div className="col-md-4">


        <div className="card mt-0">
          <div className="card-body flex-wrap">
            <h5 className="card-title">Race user name</h5>

            <Form onSubmit={handleRaceUsername} ref={form}>
              <strong>New name:</strong>
              <Input
                className="form-control"
                name="race_username"
                value={raceUserName}
                onChange={onChangeRaceUsername}
                disabled={raceDisabled}
                title={raceDisabled ? contactRage : ""}
              />
              <p></p>
              <p></p>
              <div className="form-group">
                <button
                  className="btn btn-primary btn-block"
                  disabled={raceDisabled}
                  title={raceDisabled ? contactRage : ""}
                >Change user name</button>
              </div>
              <CheckButton
                style={{ display: "none" }}
              />
            </Form>
          </div>
        </div>

        <div className="card mt-0">
          <div className="card-body flex-wrap">
            <h5 className="card-title">Password</h5>
            <Form onSubmit={handleRegister} ref={form}>
              <strong>New password:</strong>
              <Input
                type="password"
                className="form-control"
                name="password"
                value={password}
                onChange={onChangePassword}
                validations={[required]}
              />
              <p></p>
              <strong>Confirm new password:</strong>
              <Input
                type="password"
                className="form-control"
                name="password2"
                value={password2}
                onChange={onChangePassword2}
                validations={[required]}
              />
              <p></p>
              <div className="form-group">
                <button className="btn btn-primary btn-block">Change password</button>
              </div>

              {messagePassword && (
                <div className="form-group">
                  <div
                    className={
                      successful ? "alert alert-success" : "alert alert-danger"
                    }
                    role="alert"
                  >
                    {messagePassword}
                  </div>
                </div>
              )}

              <CheckButton style={{ display: "none" }} ref={checkBtn} />
            </Form>
          </div>
        </div>

        <div className="card mt-0">
          <div className="card-body flex-wrap">
            <h5 className="card-title">Unregister device</h5>
            <Form onSubmit={handleUnregisterDevice} ref={form}>
              <Select
                value={selectedDevice}
                onChange={handleDeviceChange}
                options={deviceOptions}
                isClearable={true}
                isSearchable={true}
                placeholder="Select a device"
                theme={customSelectTheme}
              />
              <p></p>
              <div className="form-group">
                <button className="btn btn-primary btn-block" disabled={!selectedDevice}>
                  Unregister
                </button>
              </div>
              <CheckButton style={{ display: "none" }} ref={checkBtn} />
            </Form>
          </div>
        </div>

        <div className="card mt-0">
          <div className="card-body flex-wrap">
            <h5 className="card-title">Account informations</h5>
            <p>
              <strong>Email:</strong> {currentUser.email}
            </p>
            <p>
              <strong>Authorities:</strong> {currentUser.roles[0]}
            </p>
            <button type="button" className="btn btn-primary btn-block" onClick={handleDelete}>
              Delete account
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
